import $ from 'jquery';
export const initializePaymentSummary = () => {   
    $('.flight-change-container .btn').on('click', () => $.magnificPopup.close());   
}

export const updateBookNowAmount = () => {
    const totalPrice = $('#totalPaynow').text();
    $('.getTotalPrice', '#paymentContinueButton')
        .animate({ opacity: 0.3 }, 300, 'linear', function () {
            $(this).text(totalPrice);
        })
        .animate({ opacity: 1 }, 500);
}
 